import axios from 'axios';
import cfg from 'config';
import store from 'store/index'
import { setMember } from 'store/actions'


const TokenKey = 'token'

// create an axios instance
const service = axios.create({
  baseURL: cfg.baseUrl, 
  timeout: 50000 
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 请求头
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json'
    }
    config.headers[TokenKey] = getToken()
    return config
  },
  error => {
    console.log(error) 
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  
  response => {
    
    if(response.request.responseType && response.request.responseType === 'blob'){
      return response
    }
    if(!response.data) return response
    let res = response.data
    // code 200 结果成功
    if (res.code !== 200) {
      
      // 501 登录验证失败 502 凭证过期
      if (res.code === 501 || res.code === 502) {
        // to re-login
        // 清除token redux中store用户信息
        store.dispatch(setMember({
          memberId: null,
          name: ''
        }))
        setToken('')
        window.reactHistory.push('/login')
      }else{
      }
      //return Promise.reject(new Error(res.msg || 'Error'))
      return res
    } else {
      // 如果是https请求 替换http资源
      const baseUrl = window.location.origin
      if(baseUrl.startsWith('https')){
        let str = JSON.stringify(res)
        str = str.replaceAll('http://guduxiong.cn', 'https://guduxiong.cn')
        res = JSON.parse(str)
      }
      return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}


// 接口获取blod后下载文件
const downloadFile = (response, filename)=>{
  // 创建Blob对象，设置文件类型
  const type = response.type
  const blod = new Blob([response.data], { type: response.headers['content-type'] })
  let objectUrl = URL.createObjectURL(blod); // 创建URL
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename; // 自定义文件名
  link.click(); // 下载文件
  URL.revokeObjectURL(objectUrl); // 释放内存
}

export {
  downloadFile
}

export default service
